import { NonIdealState } from '@acp/core-ui';
import { brandIcons } from '@acp/core-ui/assets';
import { useSession } from '@acp/feature/auth';
import {
    Flex,
    Heading,
    Image, Text, VStack,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TrackingAction, TrackingActionCategory } from '@acp/shared';
import { addTrackingEvent } from '../hooks/use-tracking-event';

function NotFoundPage() {
    const location = useLocation();
    const session = useSession();

    useEffect(() => {
        addTrackingEvent({
            category: TrackingActionCategory.App,
            action: TrackingAction.PageNotFound,
            context: {
                path: location.pathname,
            },
        });
    }, []);

    return (
        <NonIdealState
            py={10}
            iconComponent={<Image src={brandIcons.noResultProperty} />}
            title="404 Not Found"
            description=""
        >
            <VStack>
                <Text>
                    The page you&apos;re looking for doesn&apos;t exist
                </Text>
                <VStack gap={0}>
                    <Text fontSize="sm">
                        Ref:
                        {' '}
                        {session.complianceUserId}
                        -
                        {session.complianceAgencyId}
                        -
                        {session.complianceAgencyState}
                    </Text>
                    <Text fontSize="sm">
                        Route:
                        {' '}
                        {location.pathname}
                    </Text>
                </VStack>
            </VStack>
        </NonIdealState>
    );
}

function UnauthedNotFoundPage() {
    const location = useLocation();

    useEffect(() => {
        addTrackingEvent({
            category: TrackingActionCategory.App,
            action: TrackingAction.PageNotFound,
            context: {
                path: location.pathname,
            },
        });
    }, []);

    return (
        <Flex flexDir="column" width="100%">
            <Flex width="100%" alignItems="center" mb={6}>
                <Heading fontSize="3xl" flexGrow={1}>
                    404 Not Found
                </Heading>
            </Flex>
            <Text fontSize="lg">The page you&apos;re looking for doesn&apos;t exist</Text>
        </Flex>
    );
}

export { NotFoundPage, UnauthedNotFoundPage };
